import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useTeamMedianHourlyCost = (teamId: string | undefined, medianTrietia: number | null) => {
  return useQuery<number | null>({
    queryKey: ['team-median-hourly-cost', teamId, medianTrietia],
    queryFn: async (): Promise<number | null> => {
      if (!teamId || medianTrietia === null) return null;

      // Get the admin ID for the team
      const { data: team, error: teamError } = await supabase
        .from('teams')
        .select('created_by')
        .eq('id', teamId)
        .single();

      if (teamError) throw teamError;
      if (!team?.created_by) return null;

      // Get parent admin if contributor
      const { data: parentAdminId } = await supabase.rpc('get_parent_admin', { 
        user_id: team.created_by 
      });
      const effectiveAdminId = parentAdminId || team.created_by;

      // Round median trietia to nearest integer for lookup
      const roundedTrietia = Math.round(medianTrietia);

      // Get the hourly cost for this trietia level
      const { data: costData, error: costError } = await supabase
        .from('hourly_costs')
        .select('cost_per_hour')
        .eq('admin_id', effectiveAdminId)
        .eq('trietia', roundedTrietia)
        .maybeSingle();

      if (costError) throw costError;

      return costData?.cost_per_hour || null;
    },
    enabled: !!teamId && medianTrietia !== null,
  });
};

